import { defineComponent as _defineComponent } from 'vue'
import PlaidIntegrationsTestComponent from '@/app/components/integrations/PlaidIntegrationsTestComponent.vue';

/**
 * Plaid integrations view
 *
 * This exists in the settings pages, but is purposefully hidden from the settings menus
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PlaidIntegrationsView',
  setup(__props) {


return { __sfc: true,PlaidIntegrationsTestComponent }
}

})